import Header from "../public/Header";
import Footer from "../public/Footer";
import styles from "../../styles/public/layout.module.css";

const Layout = ({ children, showNavigation, navigationProps, organization }) => {
    return (
        <div className={styles["layout"]}>
            <Header organization={organization} handleCancel={navigationProps?.handleCancel} />
            <main className={styles["main-content"]}>{children}</main>
            <Footer
                showNavigation={showNavigation}
                onClick={navigationProps?.onClick}
                handleContinue={navigationProps?.handleContinue}
                disabled={navigationProps?.disabled}
                continueText={navigationProps?.continueText} 
                showContinueButton={navigationProps?.showContinueButton}
            />
        </div>
    )
};

export default Layout;